import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  getBuyerTypeName,
  getPromotionName,
  getPromotionColor,
} from "../../utils/verifier.utils";
import { FormattedMessage } from "react-intl";

class TicketInfoHeader extends Component {
  render() {
    const { ticketInfo } = this.props;

    return ticketInfo && ticketInfo.length > 0 ? (
      <div className="header">
        <ul>
          {ticketInfo[0].buyerTypeId && ticketInfo[0].buyerTypeId !== null && (
            <li>
              <label className="label-custom">
                <FormattedMessage
                  defaultMessage="Colectivo"
                  id="label.type.buyer"
                />
              </label>
              <p>{getBuyerTypeName(ticketInfo[0].buyerTypeId)}</p>
            </li>
          )}
          <li>
            <label className="label-custom">
              <FormattedMessage
                defaultMessage="Localicador de reserva"
                id="label.locator.reservation"
              />
            </label>
            {ticketInfo.map((ticketInfo, index) => (
              <p key={`p-ticketinfo-${index}`}>{ticketInfo.reservationId}</p>
            ))}
          </li>
          <li>
            <label className="label-custom">
              <FormattedMessage
                defaultMessage="Localizador de entrada"
                id="label.locator.ticket"
              />
            </label>
            {ticketInfo.map((ticketInfo, index) => (
              <p key={`p-ticketInfo-${index}`}>
                {ticketInfo.ticketId
                  ? ticketInfo.ticketId
                  : ticketInfo.ticketGroupId}
              </p>
            ))}
          </li>

          {ticketInfo[0].promotionId && (
            <li>
              <div className="promotion">
                <div>
                  <span
                    style={
                      getPromotionColor(ticketInfo[0].promotionId)
                        ? {
                            color: getPromotionColor(ticketInfo[0].promotionId),
                          }
                        : {}
                    }
                    className="icon-own-star"
                  >
                    {" "}
                  </span>
                </div>
                <div className="text-left">
                  <label className="label-custom">
                    <FormattedMessage
                      defaultMessage="Promoción"
                      id="label.promotion"
                    />
                  </label>
                  <p>{getPromotionName(ticketInfo[0].promotionId)}</p>
                </div>
              </div>
            </li>
          )}
        </ul>
      </div>
    ) : (
      <div>Loading...</div>
    );
  }
}
TicketInfoHeader.PropTypes = {
  ticketInfo: PropTypes.object.isRequired,
};

export default TicketInfoHeader;
